import { observer } from 'mobx-react';
import type { FC } from 'react';
import type { HeaderSearchSettings } from '../..';
import { Link } from '@compat/router';

interface SearchTipsProps {
  tips: HeaderSearchSettings['tips'];
}

const SearchTips: FC<SearchTipsProps> = ({ tips }) => (
  <ul
    className='flex flex-wrap w-full gap-2 text-sm leading-none '
    onMouseDown={e => {
      e.preventDefault();
    }}
  >
    {tips.map(item => (
      <li key={item.query} className='w-max bg-[var(--light-grey)] rounded-lg'>
        <Link
          onClick={e => {
            e.stopPropagation();
          }}
          to={`/search?query=${item.query}`}
          className='px-3 h-[34px] rounded-lg flex items-center '
        >
          {item.label}
        </Link>
      </li>
    ))}
  </ul>
);

export default observer(SearchTips);
